<div class="video-drop-block">
  <div *ngIf="blockElement?.isActiveForEdit" class="video-block-default">
    <div class="d-flex flex-column w-25">
      <input *ngIf="blockElement?.isActiveForEdit" type="url" class="form-control video-input"
        placeholder="Enter Video URL" [ngModel]="blockElement?.data" (ngModelChange)="onChange($event)">
      <div [ngStyle]="{'opacity':!isValidUrl?1:0}" class="invalid-feedback d-block"> Please
        enter valid Url.</div>
    </div>
  </div>
  <div *ngIf="!blockElement?.isActiveForEdit" class="video-view-block">
    <iframe *ngIf="isYoutubeUrl " class="youtube-video-block" [src]="value" frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen></iframe>
    <video *ngIf="!isYoutubeUrl" style="height:480px;width:100%;" [src]="value" alt="More About Restuarant" controls=""
      controlslist="nodownload" autoplay="" loop="" type="video/mp4">
    </video>
  </div>
</div>